import React from 'react'
import { object } from 'prop-types'
import moment from 'moment'
import numeral from 'numeral'
import classNames from 'classnames/bind'

function formatDegree (value) {
  if (value === 0) return '-0.00'
  return numeral(value).format('+0.00')
}

function formatDiscount (value) {
  if (value) {
    const m = value.toString().match(/0\.(\d+)/)
    if (Array.isArray(m) && m[1]) return `${m[1]}折`
  }
  return ''
}


function Print ({ value, style }) {
  const cx = classNames.bind(style)
  const orderName = '出　貨　單'
  const formattedKey = typeof value.key === 'string' ? value.key.replace(/(.{7})/, '$1 ') : ''

  const updatedTimeString = moment(value['@@updatedAt']).isValid ?
    moment(value['@@updatedAt']).format('YYYY/M/D HH:mm:ss') : ''

  const orderDateString = moment(value.orderDate).isValid ?
    moment(value.orderDate).format('YYYY/M/D') : ''

  const deliveryNote = (value.deliveryNote ? value.deliveryNote : '')
    + (value.orderType === '寄賣' ? ' (寄賣)' : '')

  return (
    <div className={style.print}>
      <div className={style['header-left']}>
        <div data-name="貨單號碼">
          <div className={style['print-name']}>貨單號碼：</div>
          <div className={style['print-data']}>{formattedKey}</div>
        </div>
        <div data-name="客戶代號">
          <div className={style['print-name']}>客戶代號：</div>
          <div className={style['print-data']}>{value.customerKey}</div>
        </div>
        <div data-name="客戶名稱">
          <div className={style['print-name']}>客戶名稱：</div>
          <div className={style['print-data']}>{value.customerName}</div>
        </div>
        <div data-name="客戶地址">
          <div className={style['print-name']}>客戶地址：</div>
          <div className={style['print-data']}>
            {value.customerZip}{value.customerAddress} {value.customerPhone}
          </div>
        </div>
      </div>
      <div className={style['header-right']}>
        <div data-name="採購單號">
          <div className={style['print-name']}>採購單號：</div>
          <div className={style['print-data']}>{value.custOrderNo}</div>
        </div>
        <div data-name="出貨日期">
          <div className={style['print-name']}>出貨日期：</div>
          <div className={style['print-data']}>{orderDateString}</div>
        </div>
        <div data-name="專員">
          <div className={style['print-name']}>專　　員：</div>
          <div className={style['print-data']}>{value.salesRepName}-{value.orderStafferKey}</div>
        </div>
        <div data-name="手機">
          <div className={style['print-name']}>手　　機：</div>
          <div className={style['print-data']}>{value.salesRepPhone}</div>
        </div>
      </div>
      <div className={style['order-name']}>
        <div data-name="列印單名稱">{orderName}</div>
        <div data-name="列印時間">{updatedTimeString}</div>
      </div>
      <div className={style['order-list']}>
        <div className={style.head}>
          <div data-name="客戶說明-name">客戶說明</div>
          <div data-name="客戶說明">{deliveryNote}</div>
          <div data-name="品牌名稱-name">品牌</div>
          <div data-name="品牌名稱">{value.brandKey}</div>
        </div>
        <div className={style['items-name']}>
          <div className={style['print-name']} data-name="代碼">代　碼</div>
          <div className={style['print-name']} data-name="品名">品　　名</div>
          <div className={style['print-name']} data-name="規格">規　　格</div>
          <div className={style['print-name']} data-name="數量">數量</div>
          <div className={style['print-name']} data-name="單價">單價</div>
          <div className={style['print-name']} data-name="金額">金額</div>
          <div className={style['print-name']} data-name="備註">備註</div>
        </div>
        <div className={style.items}>
          {value.items && value.items.map((item, i) => {
            if (item.productRef) {
              const isTypeE = item.productRef.type === 'E'
              const { productRef, lensSpec } = item
              return (
                <div className={style.item} key={i}>
                  <div data-name="代碼" className={cx({ 'text-right': isTypeE })}>
                    {productRef.key}
                  </div>
                  <div data-name="品名" className={cx({ 'text-right': isTypeE })}>
                    {productRef.name}
                  </div>
                  {productRef.type === 'B' ?
                    <div data-name="規格">
                      <div data-name="訂製">
                        {(typeof productRef.key === 'string' && productRef.key.search(/R$/) >= 0) ?
                          '訂製' : ''}
                      </div>
                      <div data-name="左右">{lensSpec.eye}</div>
                      <div data-name="s">{`S${formatDegree(lensSpec.s)}`}</div>
                      <div data-name="c">{`C${formatDegree(lensSpec.c)}`}</div>
                      <div data-name="a">{lensSpec.a ? `A${lensSpec.a}` : ''}</div>
                      <div data-name="add">
                        {lensSpec.add ? `ADD${formatDegree(lensSpec.add)}` : ''}
                      </div>
                    </div>
                  :
                    <div data-name="規格"> {item.productSpec} </div>
                  }
                  <div data-name="數量">{item.qty}</div>
                  <div data-name="單價">{value.printPrice ? item.unitPrice : ''}</div>
                  <div data-name="金額">{value.printPrice ? item.subtotal : ''}</div>
                  <div data-name="備註">{formatDiscount(item.discount)} {item.itemNote}</div>
                </div>
              )
            }
            return null
          })}
        </div>
        <div className={style.foot}>
          <div data-name="廣告"></div>
          <div data-name="合計-name">合計</div>
          <div data-name="合計">{value.summary}</div>
          <div data-name="總金額">{value.printPrice ? value.total : ''}</div>
        </div>
      </div>
    </div>
  )
}

Print.propTypes = {
  value: object,
  style: object.isRequired,
}

export default Print



// WEBPACK FOOTER //
// ./src/components/SalesOrderEditor/Print.jsx